import { SVGProps, Ref, forwardRef } from 'react';

export const StackoverflowBrandSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.95 10.025h1.245V15H2v-4.975h1.244v3.731h8.707z"
            fill="#BBBBBB"
        />
        <path
            d="m4.6 9.655 6.109 1.284.256-1.221-6.109-1.285zm.808-2.925 5.659 2.635.527-1.132-5.659-2.635zm1.566-2.777 4.797 3.995.8-.96-4.798-3.994zM10.07 1l-1.002.745 3.725 5.01 1.002-.746zM4.488 12.512h6.22v-1.244h-6.22z"
            fill="#F58025"
        />
    </svg>
));
StackoverflowBrandSize16Glyph.displayName = 'StackoverflowBrandSize16Glyph';
